import { render } from "./BasicTable.vue?vue&type=template&id=0ef90caa"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"
script.render = render

export default script